import { Outlet } from "react-router-dom";
import Navbar from "../pages/mainPages/Navbar";

const AuthLayout = () => {
  return (
    <div className="relative">
      <Navbar  />
      <Outlet />
    </div>
  )
}

export default AuthLayout;